import { TextField, TextInput, NumberField, NumberInput } from "react-admin";
import { RecordSummary, MyShow } from "../ra-lb-tools/components/MyShow";
import { useParams } from "react-router-dom";
import BusinessIcon from "@mui/icons-material/Business";
import {
  MyReferenceField,
  MyReferenceInput,
} from "../ra-lb-tools/components/myReference";
import { MyList } from "../ra-lb-tools/components/myList";
import {
  MyEdit as Edit,
  MyCreate as Create,
} from "../ra-lb-tools/components/myMutator";
import { LabeledColumn } from "../ra-lb-tools/components/labeledColumn";
import { LockerList } from "./lockers";
import { ProductList } from "./billing/products";
import * as myTabbedShowLayout from "../ra-lb-tools/components/myTabbedShowLayout";

export const LockerTypeIcon = BusinessIcon;

export const LockerTypeList = (props) => (
  <MyList {...props} resource="locker-types">
    <TextField source="id" />
    <TextField source="name" />
    <TextField source="description" />
    <TextField source="lockerProviderType" />
    <NumberField source="relWidth" />
    <NumberField source="relHeight" />
    <NumberField source="sortOrder" />
    <NumberField source="lockerCount" sortable={false} />
  </MyList>
);

export const LockerTypeEdit = (props) => {
  return (
    <Edit {...props}>
      <TextInput source="id" disabled />
      <TextInput source="name" />
      <TextInput source="description" multiline />
      <TextInput source="lockerProviderType" />
      <NumberInput source="relWidth" />
      <NumberInput source="relHeight" />
      <NumberInput source="sortOrder" />
    </Edit>
  );
};

export const LockerTypeCreate = (props) => {
  return (
    <Create {...props}>
      <TextInput source="name" />
      <TextInput source="description" multiline />
      <NumberInput source="relWidth" />
      <NumberInput source="relHeight" />
    </Create>
  );
};

export const LockerTypeShow = () => {
  const id = parseInt(useParams()["id"]);

  return (
    <MyShow>
      <myTabbedShowLayout.MyTabbedShowLayout>
        <myTabbedShowLayout.Tab label="Summary" can={true}>
          <RecordSummary>
            <LabeledColumn>
              <TextField source="id" />
              <TextField source="name" />
              <TextField source="description" />
              <NumberField source="sortOrder" />
            </LabeledColumn>
            <LabeledColumn>
              <NumberField source="relWidth" />
              <NumberField source="relHeight" />
              <NumberField source="lockerCount" />
            </LabeledColumn>
          </RecordSummary>
        </myTabbedShowLayout.Tab>
        <myTabbedShowLayout.Tab
          label="Lockers"
          path="lockers"
          can={{ action: "list", resource: "lockers" }}
        >
          <LockerList filter={{ typeId: id }} />
        </myTabbedShowLayout.Tab>
        <myTabbedShowLayout.Tab
          label="Products"
          path="products"
          can={{ action: "list", resource: "products" }}
        >
          <ProductList filter={{ lockerTypeId: id }} />
        </myTabbedShowLayout.Tab>
      </myTabbedShowLayout.MyTabbedShowLayout>
    </MyShow>
  );
};

export const LockerTypeInput = (props) => {
  return <MyReferenceInput source="type" reference="locker-types" {...props} />;
};

export const LockerTypeField = (props) => {
  return <MyReferenceField source="type" reference="locker-types" {...props} />;
};
